import { Box } from '@mantine/core'

import { useDocumentState } from '../../hooks/useDocumentState'
import { useDocumentTranslation } from '../../hooks/useDocumentTranslation'
import { SectionContractContent } from './SectionContractContent'
import { SectionCustomer } from './SectionCustomer'
import { SectionFooter } from './SectionFooter'
import { SectionHeader } from './SectionHeader'
import { SectionItems } from './SectionItems'
import { SectionServices } from './SectionServices'
import { SectionSignature } from './SectionSignature'
import { SectionSummary } from './SectionSummary'
import { SectionTermsAndConditions } from './SectionTermsAndConditions'
import styles from './styles.module.css'

export function DocumentContractPreview() {
  const { isLoaded } = useDocumentState()

  useDocumentTranslation()

  if (!isLoaded) {
    return null
  }

  return (
    <Box className={styles.document}>
      <SectionHeader />
      <SectionCustomer mt='lg' />
      <SectionItems mt='lg' />
      <SectionServices mt='lg' />
      <SectionSummary mt='lg' />
      <SectionContractContent mt='lg' />
      <SectionSignature mt='lg' />
      <SectionFooter mt='lg' />
      <SectionTermsAndConditions mt='lg' />
    </Box>
  )
}
